import { render, staticRenderFns } from "./NotificationModule.vue?vue&type=template&id=b3295f7a"
import script from "./NotificationModule.vue?vue&type=script&lang=js"
export * from "./NotificationModule.vue?vue&type=script&lang=js"
import style0 from "./NotificationModule.vue?vue&type=style&index=0&id=b3295f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports